import { cn, PropsWithClassName } from "kz-ui-sdk";

interface TextGradientProps extends PropsWithClassName {
  className?: string;
  text: string;
  variant?: TextGradientVariant;
  classes?: {
    label?: string;
    labelOverlay?: string;
  };
}

type TextGradientVariant = "primary" | "secondary";

const TextGradient = ({ className, text, variant = "primary", classes }: TextGradientProps) => {
  return (
    <div className={cn("relative h-[35px] w-full", className)}>
      <span
        className={cn(
          "absolute left-1/2 top-[1px] -translate-x-1/2 will-change-transform",
          "pl-[0.5px] pt-[1px] text-2xl font-bold leading-8 [-webkit-text-stroke:0.5px_currentColor] [text-shadow:0px_2px_0px_rgba(0,0,0,0.20),0px_1px_0px_currentColor]",
          VARIANTS[variant].label,
          classes?.label,
        )}
      >
        {text}
      </span>
      <span
        className={cn(
          "absolute left-1/2 top-0 -translate-x-1/2 will-change-transform",
          "bg-clip-text text-2xl font-bold leading-8 text-transparent",
          VARIANTS[variant].labelOverlay,
          classes?.labelOverlay,
        )}
      >
        {text}
      </span>
    </div>
  );
};

const VARIANTS: Record<
  TextGradientVariant,
  {
    label: string;
    labelOverlay: string;
  }
> = {
  primary: {
    label: "text-darkBrand-600",
    labelOverlay: "bg-pageTitle",
  },
  secondary: {
    label: "text-darkBrand-600",
    labelOverlay: "bg-pageTitle",
  },
};

export default TextGradient;
